import React from "react";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  displayMoveUpDownButtons: (
    index: number,
    itemsCount: number,
    moveUp: any,
    moveDown: any
  ) => JSX.Element;
  keyProp: number;
  content: any;
  saveContentInStore: any;
  generator: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
}

const MoveStepButtons = (props: Props): JSX.Element => {
  const {
    displayMoveUpDownButtons,
    keyProp,
    content,
    saveContentInStore,
    generator,
    contentType,
    currentInputData,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  return displayMoveUpDownButtons(
    keyProp,
    content.items.length,
    () => {
      saveContentInStore(
        generator.moveStepUp({ [contentType]: currentInputDataRef.current }, keyProp)
      );
    },
    () => {
      saveContentInStore(
        generator.moveStepDown({ [contentType]: currentInputDataRef.current }, keyProp)
      );
    }
  );
};

export default MoveStepButtons;
